import { Counter } from "components/Counter/Counter";
import { numberFormat } from "helper/numberFormat";
import React from "react";
import {
  TicketsCardContainer,
  TicketsCardHead,
  TicketsCardName,
  TicketsCardNameForMemberOnly,
  TicketsCardPrice,
  TicketsCardQuantity,
} from "./Theme";
import { getAuthenticated } from "utils/functions";

const TicketCard = ({
  variant,
  handleQuantityChange,
  totalTicket,
  allowNonMembers,
}) => {
  const isAuthenticated = getAuthenticated();

  const availableQty = variant.infiniteQuantity
    ? Infinity
    : Math.max(0, (variant.quantity || 0) - (variant.reserveProduct || 0));
  const isSoldOut = !variant.infiniteQuantity && availableQty <= 0;

  return (
    <TicketsCardContainer
      isDisabled={
        isSoldOut ||
        (!allowNonMembers && !isAuthenticated) ||
        (variant.forMemberOnly && !isAuthenticated)
      }
    >
      <TicketsCardHead>
        <TicketsCardName>
          {variant.name}
          <TicketsCardNameForMemberOnly>
            {isSoldOut
              ? "(Sold Out)"
              : (!allowNonMembers && !isAuthenticated) ||
                (variant.forMemberOnly && !isAuthenticated)
              ? "(Members Only)"
              : ""}
          </TicketsCardNameForMemberOnly>
        </TicketsCardName>
        <TicketsCardQuantity>
          <Counter
            width={"auto"}
            counter={variant.selectedQuantity}
            handleClickIncrement={() => {
              if (
                isSoldOut ||
                totalTicket >= 20 ||
                (!variant.infiniteQuantity &&
                  variant.selectedQuantity >= availableQty) ||
                (variant.forMemberOnly && !isAuthenticated) ||
                (!allowNonMembers && !isAuthenticated)
              )
                return;
              handleQuantityChange(variant.selectedQuantity + 1, "increment");
            }}
            handleClickDecrement={() => {
              if (
                variant.selectedQuantity === 0 ||
                (variant.forMemberOnly && !isAuthenticated) ||
                (!allowNonMembers && !isAuthenticated)
              )
                return;
              handleQuantityChange(variant.selectedQuantity - 1, "decrement");
            }}
            disabled={
              isSoldOut ||
              totalTicket >= 20 ||
              (!allowNonMembers && !isAuthenticated) ||
              (variant.forMemberOnly && !isAuthenticated) ||
              (!variant.infiniteQuantity && variant.selectedQuantity >= availableQty)
            }
            disabledDecrement={variant.selectedQuantity === 0}
          />
        </TicketsCardQuantity>
      </TicketsCardHead>
      <TicketsCardPrice>
        {variant.amount
          ? numberFormat({
              number: variant.amount,
              decimal: 2,
              style: "currency",
            })
          : ""}
      </TicketsCardPrice>
    </TicketsCardContainer>
  );
};

export default TicketCard;
